import type { ISize } from './types';

export const getSizeFromRatio = (
  size: Partial<ISize>,
  ratio: number,
): ISize => {
  if (size.width && size.height) {
    return {
      width: size.width,
      height: size.height,
    };
  }

  if (size.width && !size.height) {
    return {
      width: size.width,
      height: size.width / ratio,
    };
  }

  if (size.height && !size.width) {
    return {
      width: size.height * ratio,
      height: size.height,
    };
  }

  throw new Error(
    'Invalid size object. Must have at least one of width or height.',
  );
};
